/** Fase 2 (W25, K14): textos do cartão "Condições de compra" da ficha do fornecedor (namespace `cadastros`). */
export const fornecimentoPt = {
  fornecimento: {
    titulo: 'Condições de compra',
    editar: 'Editar condições',
    definir: 'Definir condições',
    vazio: 'Sem condições definidas. Compras e pedidos novos deste fornecedor começam à vista.',
    explicacao: 'Valem como padrão nas compras e nos pedidos novos deste fornecedor. O pedido mínimo só avisa, não impede.',
    condicao: 'Condição de pagamento',
    condicaoAjuda: 'À vista, um prazo (30) ou parcelas (30/60/90), em dias.',
    forma: 'Forma de pagamento',
    prazo: 'Prazo de entrega (dias)',
    minimo: 'Pedido mínimo',
    observacao: 'Observação',
    avista: 'À vista',
    dias_one: '{{count}} dia',
    dias_other: '{{count}} dias',
    formaInativa: '{{nome}} (inativa)',
  },
};

type Dic = typeof fornecimentoPt;

export const fornecimentoEn: Dic = {
  fornecimento: {
    titulo: 'Purchase terms',
    editar: 'Edit terms',
    definir: 'Set terms',
    vazio: 'No terms set. New purchases and orders from this supplier start as paid upfront.',
    explicacao: 'Used as the default in new purchases and orders from this supplier. The minimum order only warns, it does not block.',
    condicao: 'Payment terms',
    condicaoAjuda: 'Upfront, one term (30) or installments (30/60/90), in days.',
    forma: 'Payment method',
    prazo: 'Lead time (days)',
    minimo: 'Minimum order',
    observacao: 'Note',
    avista: 'Upfront',
    dias_one: '{{count}} day',
    dias_other: '{{count}} days',
    formaInativa: '{{nome}} (inactive)',
  },
};

export const fornecimentoEs: Dic = {
  fornecimento: {
    titulo: 'Condiciones de compra',
    editar: 'Editar condiciones',
    definir: 'Definir condiciones',
    vazio: 'Sin condiciones definidas. Las compras y los pedidos nuevos de este proveedor empiezan al contado.',
    explicacao: 'Valen como estándar en las compras y los pedidos nuevos de este proveedor. El pedido mínimo solo avisa, no impide.',
    condicao: 'Condición de pago',
    condicaoAjuda: 'Al contado, un plazo (30) o cuotas (30/60/90), en días.',
    forma: 'Forma de pago',
    prazo: 'Plazo de entrega (días)',
    minimo: 'Pedido mínimo',
    observacao: 'Observación',
    avista: 'Al contado',
    dias_one: '{{count}} día',
    dias_other: '{{count}} días',
    formaInativa: '{{nome}} (inactiva)',
  },
};
